export default class CreditBook {
	static typeSearch = "local"; //online || local
	properties = {
		nom: "",
		bnf: [],
		cnt: 0,
		mul: 1,
		exp: { i: "", f: "" },
		Tenant: "",
		id: null,
		prs: [],
	}
	constructor(data = null) {
		this.properties.id = (data?.id) ? data.id : null
		this.properties.nom = (data?.nom) ? data.nom : ""
		this.properties.bnf = (data?.bnf) ? data.bnf : []
		this.properties.cnt = (data?.cnt) ? data.cnt : 0
		this.properties.mul = (data?.mul) ? data.mul : 1
		this.properties.exp = (data?.exp) ? data.exp : { i: "", f: "" }
		this.properties.prs = (data?.prs) ? data.prs : []
		this.properties.Tenant = (data?.Tenant) ? data.Tenant : ""
	}

	static getPropertyModel() {
		const cb = new CreditBook()
		return cb.properties;
	}

}